<template>
	<div :class="['input', className]">
		<label :for="inputId" class="input__label">{{ label }}</label>
		<textarea
			v-if="isTextarea"
			:id="inputId"
			class="input__field input__field_textarea"
			:placeholder="placeholder"
			:rows="rows"
			:value="modelValue"
			@input="$emit('update:modelValue', $event.target.value)"
		></textarea>
		<input
			v-else
			:id="inputId"
			:type="type"
			class="input__field"
			:placeholder="placeholder"
			:value="modelValue"
			@input="$emit('update:modelValue', $event.target.value)"
		/>
	</div>
</template>

<script>
export default {
	name: 'BaseInput',
	props: {
		modelValue: String,
		className: String,
		label: { type: String, default: '' },
		type: { type: String, default: 'text' },
		placeholder: { type: String, default: '' },
		isTextarea: { type: Boolean, default: false },
	},
	computed: {
		inputId() {
			if (this.label && this.label.trim() !== '') {
				return this.label.toLowerCase().replace(/\s+/g, '-');
			}
			return 'input-' + Math.random().toString(36).slice(2);
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.input {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 5px;
	&__label {
		display: inline-block;
		font-weight: 500;
		text-transform: capitalize;
	}
	&__field {
		width: 100%;
		height: 44px;
		border-radius: var(--border-radius-primary);
		background-color: var(--bg-secondary-color);
		border: 1px solid var(--bg-third-color);
		padding: 0px 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--primary-color);
		text-align: center;
		outline: transparent;
		transition: border 0.3s ease 0s;
		font-size: var(--font-size-base);
		resize: none;
		transition: border 0.3s ease 0s;
		&:focus {
			border: 1px solid var(--primary-color);
		}
		&_textarea {
			overflow-y: auto;
			font-family: var(--font-family-inter);
			font-size: var(--font-size-base);
			line-height: var(--font-line-base);
			height: 150px;
			padding: 15px;
		}
	}
	input[type='number']::-webkit-outer-spin-button,
	input[type='number']::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type='number'] {
		-moz-appearance: textfield;
	}
}
</style>
